const Loader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary">
      <div className="flex flex-col items-center gap-6">
        <svg viewBox="0 0 200 200" width="140" height="140">
          <g transform="translate(100,100)">
            {/* Arrow 1 — top right */}
            <g>
              <path d="M 13,-58 A 60,60 0 0,1 54,27" fill="none" stroke="#b5d000" strokeWidth="8" strokeLinecap="round"/>
              <polygon points="0,-8 8,8 -8,8" fill="#b5d000" transform="translate(54,27) rotate(218)"/>
              <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="2.4s" repeatCount="indefinite"/>
            </g>
            {/* Arrow 2 — bottom */}
            <g>
              <path d="M 37,47 A 60,60 0 0,1 -37,47" fill="none" stroke="#b5d000" strokeWidth="8" strokeLinecap="round"/>
              <polygon points="0,-8 8,8 -8,8" fill="#b5d000" transform="translate(-37,47) rotate(338)"/>
              <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="2.4s" repeatCount="indefinite"/>
            </g>
            {/* Arrow 3 — top left */}
            <g>
              <path d="M -54,27 A 60,60 0 0,1 -13,-58" fill="none" stroke="#b5d000" strokeWidth="8" strokeLinecap="round"/>
              <polygon points="0,-8 8,8 -8,8" fill="#b5d000" transform="translate(-13,-58) rotate(82)"/>
              <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="2.4s" repeatCount="indefinite"/>
            </g>
          </g>

          {/* CSIP badge */}
          <rect x="70" y="83" width="60" height="34" rx="4" fill="white"/>
          <text x="100" y="107"
            textAnchor="middle"
            fontFamily="'Barlow Condensed', sans-serif"
            fontSize="20" fontWeight="800"
            fill="#1a1f4e">CSIP</text>
        </svg>

        <p className="text-secondary font-display text-lg tracking-widest uppercase">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default Loader;